/**
 * Object containing methods related to the card slider.
 */
const buildSliders = {
    _sliders: [],
    timeout: null,
    delay: 250,

    /**
     * Initializes the card slider.
     */
    init: function() {
        let self = this;
        let sliders = document.querySelectorAll('.js-slider');
        
        if(! sliders.length > 0) return;

        window.initPackage('https://cdn.jsdelivr.net/npm/@splidejs/splide@4.1.4/dist/js/splide.min.js').then(function() {
            self._sliderCreate(document.querySelectorAll('.js-slider'));
        })
        .catch(function(error) {
            console.error(error);
        });
    },

    /**
     * Creates a new Splide slider instance for each `.js-card-slider` element.
     */

    _sliderCreate(sliders) {
        let self = this;
        sliders.forEach((slider, index) => {
            if(slider.classList.contains('house-slider')) {
                self._sliders[index] = new Splide(slider, {
                    type: 'loop',
                    speed: 800,
                    
                    focus: 'center',
                    gap: '24px',
                    perPage: 2,
                    accessibility: true,
                    arrows: false,
                    keyboard: true,
                    autoplay: true,
                    pagination: false,
                    breakpoints: {
                        1500: {
                            gap: '24px',
                            perPage: 1,
                            padding: '20%'
                        },
                        991: {
                            pagination: true,
                            padding: '0'
                        },
                    }
                    }   
                ).mount();
                
                self._slideCounter(slider, index);
                self._initClickEvent(slider, index);    
            }

            if(slider.classList.contains('step-slider')) {
                self._sliders[index] = new Splide(slider, {
                    type: 'slide',
                    speed: 800,
                    padding: {right: '12%'},
                    focus: 'start',
                    gap: '48px',
                    perPage: 2,
                    accessibility: true,
                    arrows: false,
                    keyboard: true,
                    autoplay: false,
                    pagination: false,
                    breakpoints: {
                        1200: {
                            gap: '24px',
                            perPage: 1,
                            padding: {right: '30%'},
                        },
                        991: {
                            gap: '24px',
                            perPage: 1,
                            padding: {right: '20%'},
                        },
                        576: {
                            gap: '24px',
                            perPage: 1,
                            padding: 0,
                            pagination: true,
                        }
                    }
                    }   
                ).mount();
                
                if(window.innerWidth >= 576) {
                    let bar = self._sliders[index].root.parentElement.querySelector('.splide__progress-bar-inner');
            
                    let end  = self._sliders[index].Components.Controller.getEnd() + 1;
                    let rate = Math.min( ( self._sliders[index].index + 1 ) / end, 1 );
                    bar.style.width = String( 100 * rate ) + '%';
                

                    self._sliders[index].on( 'mounted move', function () {
                        let end  = self._sliders[index].Components.Controller.getEnd() + 1;
                        let rate = Math.min( ( self._sliders[index].index + 1 ) / end, 1 );
                        bar.style.width = String( 100 * rate ) + '%';
                    });
                }
                
                self._initClickEvent(slider, index);    
            }
        });
    },

    /**
     * Initializes click events for the `.js-slider__nav-next` and `.js-slider__nav-prev` buttons.
     */
    _initClickEvent(slider, index) {
        let self = this;

        let nextButton = slider.closest('section').querySelector('.js-slider__nav-next');
        let prevButton = slider.closest('section').querySelector('.js-slider__nav-prev');

        if (nextButton) {
            nextButton.addEventListener('click', () => {
                self._nextSlide(index);
            }, false);
        }

        if (prevButton) {
            prevButton.addEventListener('click', () => {
                self._prevSlide(index);
            }, false);
        }
    },

    _imgNav(sliderIndex) {
        let self = this;

        let navNodes = document.querySelectorAll('.js-slider-nav-item');
    },

    /**
     * Goes to the next slide in the specified slider.
     */
    _nextSlide(index) {
        let self = this;
        self._sliders[index].go('>');
        self._changeSlideNumber(index);
    },

    /**
     * Goes to the previous slide in the specified slider.
     */
    _prevSlide(index) {
        let self = this;
        self._sliders[index].go('<');
        self._changeSlideNumber(index);
    },

    /**
     * Destroys all Splide slider instances and re-initializes the card slider.
     */
    reInit() {
        let self = this;

        if (self._sliders.length > 0) {
            self._sliders.forEach(slider => {
                slider.destroy();
            });
        }

        self.init();
    },

    _slideCounter(slider, index) {
        let self = this;
        let totalCount = slider.closest('section').querySelector('.js-slider-count-total');

        totalCount.innerHTML = self._sliders[index].length;
        self._changeSlideNumber(index);

    },
    
    _changeSlideNumber(index) {
        let self = this;

        let countActive = self._sliders[index].root.closest('section').querySelector('.js-slider-count-active')
        if(countActive) {
            countActive.innerHTML = self._sliders[index].index + 1;
        }
    }
};

buildSliders.init();

document.addEventListener('LokiRequestEnd', function () {
    buildSliders.reInit();
});